import React, { useEffect, useState } from 'react';
import { Empty, Table } from 'antd';
import { useSelector } from 'react-redux';
import { TAppState } from 'services/store';
import { Positions } from 'services/store/enums/users.enum';
import { IProject } from 'services/store/types/projects/Projects';
import { getDisplayDayPartVievTableHeaders } from './utils/getDisplayDayPartVievTableHeaders';
import { getDisplayDayPartViewData } from './utils/getDisplayDayPartViewData';

interface IProps {
  project?: IProject;
  userId?: string;
  position?: Positions;
}

const PartDayViewProductionSchedule: React.FC<IProps> = ({
  project,
  userId,
  position,
}) => {
  const dates = useSelector((state: TAppState) => state.productionNodes.dates);
  const nodes = useSelector((state: TAppState) => state.productionNodes.nodes);

  const [columns, setColumns] = useState<any[]>([]);
  const [list, setList] = useState<any[]>([]);

  // --------------------------------------------------------------------------
  // NOTE COLUMNS
  // --------------------------------------------------------------------------
  useEffect(() => {
    if (dates.length) {
      const columnHeaders = getDisplayDayPartVievTableHeaders(
        dates,
        project,
        userId,
        position
      );
      setColumns(columnHeaders);
    }
  }, [dates]);

  // NOTE DATA
  useEffect(() => {
    if (nodes.length) {
      const newList = getDisplayDayPartViewData(nodes);
      setList(newList);
    }
  }, [nodes]);

  if (!columns.length || !list.length) return <Empty />;
  return (
    <Table
      bordered
      columns={columns}
      dataSource={nodes && columns ? list : []}
      pagination={false}
      size="small"
      scroll={{ x: 1000, y: 400 }}
    />
  );
};

export default PartDayViewProductionSchedule;
